export const setWebHeaderLogo = (state, payload) => {
    state.webHeaderLogo = payload;
};

export const setWebFooterLogo = (state, payload) => {
    state.webFooterLogo = payload;
};

export const setAppHeaderLogo = (state, payload) => {
    state.appHeaderLogo = payload;
};

export const setAppFooterLogo = (state, payload) => {
    state.appFooterLogo = payload;
};